var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatepicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.90001 0.800003C3.40295 0.800003 3.00001 1.20295 3.00001 1.7V2.6H2.10001C1.10589 2.6 0.300003 3.40589 0.300003 4.4V13.4C0.300003 14.3941 1.10589 15.2 2.10001 15.2H12.9C13.8941 15.2 14.7 14.3941 14.7 13.4V4.4C14.7 3.40589 13.8941 2.6 12.9 2.6H12V1.7C12 1.20295 11.5971 0.800003 11.1 0.800003C10.603 0.800003 10.2 1.20295 10.2 1.7V2.6H4.80001V1.7C4.80001 1.20295 4.39707 0.800003 3.90001 0.800003ZM3.90001 5.3C3.40295 5.3 3.00001 5.70295 3.00001 6.2C3.00001 6.69706 3.40295 7.1 3.90001 7.1H11.1C11.5971 7.1 12 6.69706 12 6.2C12 5.70295 11.5971 5.3 11.1 5.3H3.90001Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepicker);
export default __webpack_public_path__ + "static/media/datepicker.eb26076ebb2e95fd6d99ac4c5b66462e.svg";
export { ForwardRef as ReactComponent };